import { kanziSections } from "../../../../content/kanziSections";
import Reveal from "../../Reveal";
import SectionHeading from "../../SectionHeading";
import SpotlightCard from "../../SpotlightCard";
import Badge from "../../../Badge";

const Audience = () => (
  <section id="audience" className="section-block section-block--framed">
    <div className="section-shell">
      <SectionHeading
        eyebrow={kanziSections.audience.eyebrow}
        title={kanziSections.audience.title}
      />

      <div className="kanzi-audience__grid">
        {kanziSections.audience.segments.map((segment, index) => (
          <Reveal
            key={segment.title}
            variant={index === 0 ? "fade-right" : "fade-left"}
          >
            <SpotlightCard className="glass-panel kanzi-audience-card">
              <Badge className="kanzi-audience-card__badge">{segment.badge}</Badge>
              <h3 className="kanzi-audience-card__title">{segment.title}</h3>
              <p className="kanzi-audience-card__desc">{segment.description}</p>
              <ul className="kanzi-audience-card__bullets">
                {segment.bullets.map((bullet) => (
                  <li key={bullet}>&gt; {bullet}</li>
                ))}
              </ul>
            </SpotlightCard>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Audience;
